<template>
  <div id="app">
    <navigation></navigation>

    <!-- wrapper/holder fuer Unterseiten (z.B. clubs.html) -->
    <div ui-view ng-view class="template-wrapper ng-view" autoscroll="true">
      <router-view name="baseView" :route-name="$router.currentRoute.name" />
    </div>
  </div>
</template>

<script>
import Navigation from "./app/components/navigation-main.component.vue";
export default {
  name: "App",

  components: {
    navigation: Navigation
  },

  created() {
    document.title = "Quaese - JavaScript-, Frontend- und Webdeveloper";
    setTimeout(() => {
      window.scrollTo({
        top: 0
      });
    }, 200);
  }
};
</script>

<style lang="less" scoped></style>
